// The Replay community Discord invite: the canonical way to reach the Replay team. Single source of
// truth — import this everywhere a Discord link is rendered or named rather than re-declaring the URL.
export const DISCORD_URL = 'https://discord.gg/M5vypUYxfd'

export const SUPPORT_EMAIL = 'support@replay.io'
